// EXISTING - Keep and use
export const occupations = [
  { value: '', label: 'Select Occupation' },
  { value: 'tech', label: 'Technology/IT' },
  { value: 'finance', label: 'Finance/Banking' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'education', label: 'Education' },
  { value: 'legal', label: 'Legal' },
  { value: 'media', label: 'Media/Entertainment' },
  { value: 'arts', label: 'Arts/Creative' },
  { value: 'hospitality', label: 'Hospitality/Tourism' },
  { value: 'retail', label: 'Retail/Sales' },
  { value: 'real-estate', label: 'Real Estate' },
  { value: 'construction', label: 'Construction' },
  { value: 'government', label: 'Government' },
  { value: 'non-profit', label: 'Non-profit' },
  { value: 'student', label: 'Student' },
  { value: 'unemployed', label: 'Unemployed' },
  { value: 'other', label: 'Other' },
];

export const languages = [
  { value: 'english', label: 'English' },
  { value: 'spanish', label: 'Spanish' },
  { value: 'chinese', label: 'Chinese (Mandarin)' },
  { value: 'cantonese', label: 'Chinese (Cantonese)' },
  { value: 'russian', label: 'Russian' },
  { value: 'korean', label: 'Korean' },
  { value: 'bengali', label: 'Bengali' },
  { value: 'hindi', label: 'Hindi' },
  { value: 'french', label: 'French' },
  { value: 'arabic', label: 'Arabic' },
  { value: 'hebrew', label: 'Hebrew' },
  { value: 'italian', label: 'Italian' },
  { value: 'portuguese', label: 'Portuguese' },
  { value: 'japanese', label: 'Japanese' },
  { value: 'polish', label: 'Polish' },
  { value: 'german', label: 'German' },
  { value: 'urdu', label: 'Urdu' },
  { value: 'tagalog', label: 'Tagalog' },
  { value: 'vietnamese', label: 'Vietnamese' },
  { value: 'other', label: 'Other' },
];

// NEW - Moved from OnboardingPage.tsx for consistency
export const cleanlinessOptions = [
  { value: 'very-clean', label: 'Very clean - everything in its place' },
  { value: 'clean-organized', label: 'Clean & organized' },
  { value: 'moderately-clean', label: 'Moderately clean' },
  { value: 'relaxed-clean', label: 'Pretty relaxed about cleanliness' }
];

export const socialLevelOptions = [
  { value: 'love-hosting', label: 'Love hosting friends & parties' },
  { value: 'social-quiet', label: 'Social but not too loud' },
  { value: 'quiet-respectful', label: 'Quiet & respectful' },
  { value: 'private-minimal', label: 'Pretty private - minimal interaction' }
];

export const workScheduleOptions = [
  { value: 'standard-9-5', label: 'Standard 9-5' },
  { value: 'hybrid-remote', label: 'Hybrid remote' },
  { value: 'fully-remote', label: 'Fully remote' },
  { value: 'creative-flexible', label: 'Creative/flexible schedule' },
  { value: 'night-shift', label: 'Night shift/irregular hours' }
];

export const petOptions = [
  { value: 'none', label: 'None' },
  { value: 'cats', label: 'Cats' },
  { value: 'dogs', label: 'Dogs' },
  { value: 'other', label: 'Other pets' }
];

// REMOVED - These are no longer used in the current flow:
// - ethnicities (not collected)
// - metroDistanceOptions (not collected)  
// - religions (not collected)
// - sexualOrientations (not collected)
// - politicalViews (not collected)
// - lifestyleOptions (replaced by specific options above)